import { t } from "i18next";
import "./KPI.css";

function KPIs (props) {
    let ScoreFillWidth;
    // let SetupFillWidth, SetupColor;
    let ConstraintViolationsFillWidth;
    let ScoreColor, ViolationsColor;

    ScoreFillWidth = Math.round((props.score / 10000) * 100);
    // SetupFillWidth = Math.round((props.setupDur/ 100) * 100);
    if(props.dueDateViolations === 0) {
        ConstraintViolationsFillWidth = 0;
    } else {
        ConstraintViolationsFillWidth = Math.round((props.dueDateViolations / 10) * 100);
    }

    if (props.score <= 2500) {
        ScoreColor = "green";
    } 
    if (props.score > 2500 && props.score <= 4500) {
        ScoreColor = "orange";
    } 
    if (props.score > 4500) {
        ScoreColor = "red";
    }

    if (props.dueDateViolations === 0) {
        ViolationsColor = "green";
    } 
    if (props.dueDateViolations <= 2 && props.dueDateViolations > 0) {
        ViolationsColor = "orange";
    } 
    if (props.dueDateViolations > 2) {
        ViolationsColor = "red";
    }

    return (
        <div className="row div">
            <div className="card kpi-container col-sm-6 text-center">
                <h1>{props.score}</h1>
                <div className="progress-bar">
                    <span className="bar">
                        <span className="progress" style={{width: ScoreFillWidth + "%", background: ScoreColor}}></span>
                    </span>
                </div>
                <p>{t("score")}</p>
            </div>
            <div className="card kpi-container col-sm-6 text-center">
                <h1>{props.dueDateViolations}</h1>
                <div className="progress-bar">
                    <span className="bar">
                        <span className="progress" style={{width: ConstraintViolationsFillWidth + "%", background: ViolationsColor}}></span>
                    </span>
                </div>
                <p>{t("dueDateViolations")}</p>
            </div>
        </div>
    );
};

export default KPIs;